// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"869cd800","911":"0457d2b2"}[chunkId] + ".chunk.js";
};